<template>
  <div class="d-flex flex-column" style="height: 100%">
    <v-tabs v-model="tab" grow class="flex-grow-0">
      <v-tab
        v-for="(type, index) in types"
        :key="index"
        class="pa-0"
        style="min-width: 60px;"
      >
        <span :data-test-noty-type="type" v-if="type === 'all'">{{
          type
        }}</span>
        <v-icon :data-test-noty-type="type" v-else>{{
          getTypeIcon(type)
        }}</v-icon>
      </v-tab>
    </v-tabs>
    <v-divider class="mt-auto" />
    <v-list
      class="align-start flex-grow-1"
      style="max-height: 400px; overflow-y: auto"
    >
      <v-list-item
        :data-test="`notification_${index}`"
        @click="goToElement(`/notifications/${item.id}`)"
        v-for="(item, index) in notifications.filter(
          i => i.icon === types[tab] || tab === 0
        )"
        :key="`${item.id}_${index}`"
      >
        <v-list-item-icon>
          <v-icon :color="item.iconColor">{{ getTypeIcon(item.icon) }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="white-space: normal">
            {{ item.title.slice(0, 80) || 'n/a' }}
          </v-list-item-title>
          <v-list-item-subtitle class="body-2 text--secondary">
            {{ item.subTitle }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <div
        style="text-align: center; min-height: 50px; display: flex; align-items: center; justify-content: center"
        v-if="
          !notifications.filter(i => i.icon === types[tab] || tab === 0).length
        "
      >
        No more data
      </div>
    </v-list>
    <v-divider class="mt-auto" />
    <div class="d-flex justify-end pa-3">
      <v-btn
        text
        color="primary"
        data-test="showAllNotifications"
        class="text-uppercase"
        @click="goToList"
        >show all</v-btn
      >
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api';
import moment from 'moment';
export default {
  name: 'notificationList',
  props: {
    notifications: {
      type: Array,
      default: () => []
    }
  },
  setup(props, { root, emit }) {
    const types = ['all', '$alert', '$notice', '$message'];
    const tab = ref(0);
    const filteredNotifications = ref([]);
    function getTypeIcon(v) {
      switch (v) {
        case '$alert':
          return 'mdi-bell-ring';
        case '$notice':
          return 'mdi-volume-high';
        case '$message':
          return 'mdi-message-text';
      }
    }
    function getTypeIconFromTags(v) {
      if (v.includes('alert')) {
        return 'mdi-bell-ring';
      } else if (v.includes('notice')) {
        return 'mdi-volume-high';
      } else {
        return 'mdi-message-text';
      }
    }

    function goToElement(link) {
      root.$router.push(link);
      emit('close');
    }

    function goToList() {
      if (root.$route.name !== 'notifications') {
        root.$router.push({ name: 'notifications' });
      }

      emit('close');
    }
    return {
      getTypeIcon,
      getTypeIconFromTags,
      types,
      filteredNotifications,
      tab,
      goToList,
      goToElement
    };
  }
};
</script>
